module.exports = __webpack_public_path__ + "static/media/man-report.208ab832.jpeg";